module.exports = __webpack_public_path__ + "static/PostGrotesk-Bold-91ff09a816a6ca4683bc46cc7a4250fe.woff";